<template>
  <div class="approval-list-container">
    <CustomLoader v-if="isBusy" :width="70"></CustomLoader>
    <b-card
      no-body
      class="border-0 shadow-sm"
      style="border-radius: 8px; overflow: hidden;"
    >
        <b-tabs v-model="activeTab" card pills @input="onTabChange">
            <!-- All Tab (Index 0) -->
            <b-tab title="All">
            </b-tab>
            
            <!-- Approved Tab (Index 1) -->
            <b-tab title="Approved">
            </b-tab>

            <!-- Pending Tab (Index 2) -->
            <b-tab title="Pending">
            </b-tab>
            
            <!-- Rejected Tab (Index 3) -->
            <b-tab title="Rejected">
            </b-tab>
        </b-tabs>

      <b-card-header class="bg-white border-bottom p-0">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="mb-0 text-primary font-weight-bold">
            <i class="fa fa-check-circle mr-2"></i>Credit / Debit Note Approvals
          </h4>
          <div class="d-flex align-items-center">
             <b-input-group class="mr-3" style="width: 300px;">
              <b-input-group-prepend is-text class="bg-light border-right-0">
                <i class="fa fa-search text-muted"></i>
              </b-input-group-prepend>
              <b-form-input
                v-model="filter"
                placeholder="Search by Note ID, Series..."
                class="border-left-0 bg-light"
                @input="debounceSearch"
              />
              <b-input-group-append v-if="filter">
                  <b-button variant="link" class="text-muted" @click="clearFilter" style="text-decoration: none;">
                      <i class="fa fa-times"></i>
                  </b-button>
              </b-input-group-append>
            </b-input-group>
             <b-button variant="outline-primary" @click="getData">
                <i class="fa fa-refresh"></i> Refresh
            </b-button>
            <b-button variant="outline-success" class="ml-2" @click="exportToExcel" :disabled="isExporting">
                <b-spinner small v-if="isExporting"></b-spinner>
                <span v-else><i class="fa fa-file-excel-o"></i> Export</span>
            </b-button>
             <b-button
                v-b-toggle.filter-collapse
                variant="outline-secondary"
                class="ml-2"
            >
                <i class="fa fa-filter"></i> Filters
            </b-button>
          </div>
        </div>
        
        <b-collapse id="filter-collapse" v-model="filtersVisible">
            <b-card class="bg-light border-0 mb-3">
                <b-row>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Date Type</label>
                         <model-list-select
                            :list="dateTypeOptions"
                            v-model="filters.dateType"
                            option-value="value"
                            option-text="text"
                            placeholder="Select Date Type"
                            @input="onFilterChange"
                          />
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Date Range</label>
                          <date-range-picker
                            ref="picker"
                            :opens="openLeft"
                            v-model="dateRange"
                            :startDate="dateRange.startDate"
                            :endDate="dateRange.endDate"
                            @update="onFilterChange"
                            class="w-100"
                          >
                             <template slot="input" slot-scope="picker">
                                <div class="d-flex align-items-center form-control" style="min-width: 250px;">
                                    <i class="fa fa-calendar mr-2 text-muted"></i>
                                    <span v-if="picker.startDate && picker.endDate">
                                        {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
                                    </span>
                                    <span v-else class="text-muted">Select Date Range</span>
                                    <i class="fa fa-caret-down ml-auto text-muted"></i>
                                </div>
                            </template>
                          </date-range-picker>
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Branch</label>
                         <model-list-select
                            :list="$store.getters['common/getAllBranchList']"
                            v-model="filters.branchfilter"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Branch"
                            @input="onFilterChange"
                          />
                     </b-col>
                      <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Note Type</label>
                         <model-list-select
                             :list="noteTypeList"
                             v-model="filters.noteType"
                             option-value="value"
                             option-text="text"
                             placeholder="Select Note Type"
                             @input="onFilterChange"
                          />
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Client</label>
                         <model-list-select
                             :list="$store.getters['common/getAllClientList']"
                             v-model="filters.clientFilter"
                             option-value="clientId"
                             option-text="clientName"
                             placeholder="Select Client"
                             @input="onFilterChange"
                          />
                     </b-col>
                    <b-col md="3" class="mb-3">
                        <label class="small text-muted font-weight-bold">Shipping Line</label>
                        <model-list-select
                            :list="$store.getters['common/getAllShippingLineList']"
                            v-model="filters.slineFilter"
                            option-value="shippingId"
                            option-text="shippingLine"
                            placeholder="Select Shipping Line"
                            @input="onFilterChange"
                         />
                    </b-col>
                     <b-col md="3" class="mb-3">
                        <label class="small text-muted font-weight-bold">User</label>
                        <model-list-select
                            :list="$store.getters['common/getAllUserList']"
                            v-model="filters.userFilter"
                            option-value="userId"
                            option-text="employeeName"
                            placeholder="Select User"
                            @input="onFilterChange"
                         />
                    </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Agent/Coloader</label>
                         <model-list-select
                             :list="$store.getters['common/getAllAgentColoaderList']"
                             v-model="filters.agentFilter"
                             option-value="agntColoaderId"
                             option-text="agentName"
                             placeholder="Select Agent/Coloader"
                             @input="onFilterChange"
                          />
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Consignee</label>
                         <model-list-select
                             :list="$store.getters['common/getAllConsigneeList']"
                             v-model="filters.consigneeFilter"
                             option-value="agntColoaderId"
                             option-text="consignee"
                             placeholder="Select Consignee"
                             @input="onFilterChange"
                          />
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Transport Type</label>
                          <model-list-select
                            :list="transportOptions"
                            v-model="filters.transportType"
                            option-value="value"
                            option-text="text"
                            placeholder="Select Transport Type"
                            @input="onFilterChange"
                           />
                     </b-col>
                      <b-col md="3" class="d-flex align-items-end mb-3">
                         <b-button variant="outline-danger" size="sm" @click="clearFilters" block>
                            <i class="fa fa-times mr-1"></i> Clear Filters
                         </b-button>
                     </b-col>
                </b-row>
            </b-card>
        </b-collapse>
       
      </b-card-header>

      <b-card-body class="p-0">
            <b-table
                :items="items"
                :fields="fields"
                responsive
                show-empty
                hover
                head-variant="light"
                class="mb-0 custom-table"
            >
                <template slot="empty">
                    <div class="text-center text-muted my-5">
                        <i class="fa fa-inbox fa-3x mb-3"></i>
                        <p>No records found.</p>
                    </div>
                </template>
                
                <!-- Custom Slots -->
                <template slot="SN" slot-scope="row">
                    <span>{{ row.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>
                
                <!-- Custom Column Formatting -->
                <template slot="NoteSeries" slot-scope="row">
                    <div class="cell-content">
                        <div><strong>Type:</strong> 
                            <b-badge 
                                v-if="row.item.NoteType"
                                :variant="row.item.NoteType.toLowerCase().includes('credit') ? 'success' : 'danger'"
                            >
                                {{ row.item.NoteType }}
                            </b-badge>
                        </div>
                        <div><strong>Series:</strong> 
                            <a 
                                href="javascript:void(0)" 
                                v-if="row.item.PdfLink" 
                                @click="PrintNote(row.item.JobNo, row.item.PdfLink)" 
                                v-b-tooltip.hover :title="row.item.NoteSeries" 
                                class="text-primary font-weight-bold"
                            >
                                {{ truncateWithEllipsis(row.item.NoteSeries,15) }}
                            </a>
                            <span v-else v-b-tooltip.hover :title="row.item.NoteSeries">
                                {{ truncateWithEllipsis(row.item.NoteSeries,15) }}
                            </span>
                        </div>
                        <div><strong>Date:</strong> {{ row.item.NoteDate }}</div>
                        <div v-if="row.item.ContainerTypesArr"><strong>Container:</strong> <span v-b-tooltip.hover :title="row.item.ContainerTypesArr">{{ truncateWithEllipsis(row.item.ContainerTypesArr,20) }}</span></div>
                        <div class="text-muted small"><strong>By:</strong> {{ truncateWithEllipsis(row.item.NoteCreatedBy,15) }}</div>
                        <div class="text-muted small">{{ row.item.NoteCreatedTime }}</div>
                        <div class="text-muted small">{{ row.item.NoteCreatedTime }}</div>
                        <div class="text-muted small"><strong>Approved By:</strong>{{ row.item.ApprovedBy }}</div>
                        <div class="text-muted small"><strong>Approved Date:</strong>{{ row.item.ApprovedDate }}</div>
                    </div>
                </template>

                 <template slot="NoteAmount" slot-scope="row">
                    <div class="cell-content">
                        <div class="text-nowrap"><strong>Amt:</strong> <span class="font-weight-bold">{{ row.item.Currency }}</span> {{ row.item.NoteAmount }}</div>
                        <div v-if="row.item.NoteContent"><strong>Content:</strong> <span v-b-tooltip.hover :title="row.item.NoteContent">{{ truncateWithEllipsis(row.item.NoteContent,20) }}</span></div>
                        <div v-if="row.item.BLNumber"><strong>HBL:</strong> <span v-b-tooltip.hover :title="row.item.BLNumber">{{ truncateWithEllipsis(row.item.BLNumber,15) }}</span></div>
                        <div v-if="row.item.MasterorLinerBlNo"><strong>MBL:</strong> <span v-b-tooltip.hover :title="row.item.MasterorLinerBlNo">{{ truncateWithEllipsis(row.item.MasterorLinerBlNo,15) }}</span></div>
                        <div v-if="row.item.ValidBookingNo" class="text-muted small"><strong>Booking:</strong> {{ truncateWithEllipsis(row.item.ValidBookingNo,15) }}</div>
                    </div>
                </template>

                 <template slot="SalesSeries" slot-scope="row">
                    <div class="cell-content">
                        <div><strong>Type:</strong> {{ truncateWithEllipsis(row.item.JobType,15) }}</div>
                        <div><strong>No:</strong> <span v-b-tooltip.hover :title="row.item.JobNo">{{ truncateWithEllipsis(row.item.JobNo,15) }}</span></div>
                        <div><strong>Date:</strong> {{ row.item.JobDate }}</div>
                        <div class="text-muted small"><strong>By:</strong> {{ truncateWithEllipsis(row.item.JobRaisedBy,15) }}</div>
                        <div class="text-muted small"><strong>From:</strong> {{ truncateWithEllipsis(row.item.JobRaisedFrom,15) }}</div>
                        <div v-if="row.item.VesselVoyage" class="text-muted small"><strong>Vessel:</strong> {{ truncateWithEllipsis(row.item.VesselVoyage,15) }}</div>
                    </div>
                </template>

                 <template slot="ApprovalStatus" slot-scope="row">
                    <div class="cell-content status-column">
                        <div class="mb-1"><strong>Approval:</strong> <b-badge :variant="getStatusVariant(row.item.ApprovalStatus)" class="badge-sm">{{ row.item.ApprovalStatus }}</b-badge></div>
                        <div class="mb-1"><strong>Billing:</strong> <b-badge :variant="getStatusVariant(row.item.BillingStatus)" class="badge-sm">{{ row.item.BillingStatus }}</b-badge></div>
                        <div class="mb-1"><strong>TPT Inv:</strong> <b-badge :variant="getStatusVariant(row.item.TptInvoiceClosed)" class="badge-sm">{{ row.item.TptInvoiceClosed }}</b-badge></div>
                        <div class="mb-1"><strong>CC Inv:</strong> <b-badge :variant="getStatusVariant(row.item.CcInvoiceClosed)" class="badge-sm">{{ row.item.CcInvoiceClosed }}</b-badge></div>
                        <div class="mb-1"><strong>FF Inv:</strong> <b-badge :variant="getStatusVariant(row.item.CfInvoiceClosed)" class="badge-sm">{{ row.item.CfInvoiceClosed }}</b-badge></div>
                        <div><strong>Prealert:</strong> <b-badge :variant="getStatusVariant(row.item.PrealertStatus)" class="badge-sm">{{ row.item.PrealertStatus }}</b-badge></div>
                        <div v-if="row.item.PrealertDate" class="text-muted small"><strong>Prealert Date:</strong> {{ truncateWithEllipsis(row.item.PrealertDate,15) }}</div>
                        <div><strong>Manifest:</strong> <b-badge :variant="getStatusVariant(row.item.ManifestStatus)" class="badge-sm">{{ row.item.ManifestStatus }}</b-badge></div>
                        <div v-if="row.item.ManifestDate" class="text-muted small"><strong>Manifest Date:</strong> {{ truncateWithEllipsis(row.item.ManifestDate,15) }}</div>
                    </div>
                </template>

                 <template slot="AgentColoader" slot-scope="row">
                    <div class="cell-content">
                        <div v-if="row.item.AgentType"><strong>Type:</strong> {{ truncateWithEllipsis(row.item.AgentType,15) }}</div>
                        <div v-if="row.item.AgentColoader"><strong>Agent:</strong> <span v-b-tooltip.hover :title="row.item.AgentColoader">{{ truncateWithEllipsis(row.item.AgentColoader,15) }}</span></div>
                        <div v-if="row.item.Shipper"><strong>Shipper:</strong> <span v-b-tooltip.hover :title="row.item.Shipper">{{ truncateWithEllipsis(row.item.Shipper,15) }}</span></div>
                        <div v-if="row.item.Consignee"><strong>Consignee:</strong> <span v-b-tooltip.hover :title="row.item.Consignee">{{ truncateWithEllipsis(row.item.Consignee,15) }}</span></div>
                    </div>
                </template>

                 <template slot="Shipper" slot-scope="row">
                    <div class="cell-content">
                        <div v-if="row.item.Client"><strong>Client:</strong> <span v-b-tooltip.hover :title="row.item.Client">{{ truncateWithEllipsis(row.item.Client,15) }}</span></div>
                        <div v-if="row.item.Sline"><strong>Sline:</strong> <span v-b-tooltip.hover :title="row.item.Sline">{{ truncateWithEllipsis(row.item.Sline,15) }}</span></div>
                        <div v-if="row.item.Por"><strong>POR:</strong> {{ truncateWithEllipsis(row.item.Por,12) }}</div>
                        <div v-if="row.item.Pol"><strong>POL:</strong> {{ truncateWithEllipsis(row.item.Pol,12) }}</div>
                        <div v-if="row.item.Pod"><strong>POD:</strong> {{ truncateWithEllipsis(row.item.Pod,12) }}</div>
                        <div v-if="row.item.Fpod"><strong>FPOD:</strong> {{ truncateWithEllipsis(row.item.Fpod,12) }}</div>
                    </div>
                </template>

                 <template slot="ETADest" slot-scope="row">
                    <div class="cell-content">
                        <div v-if="row.item.ETADest"><strong>ETA:</strong> {{ row.item.ETADest }}</div>
                        <div v-if="row.item.SobDate"><strong>SOB:</strong> {{ row.item.SobDate }}</div>
                        <div v-if="row.item.EtaDestActual" class="text-muted small"><strong>ETA Actual:</strong> {{ row.item.EtaDestActual }}</div>
                        <div v-if="row.item.EtaDestEst" class="text-muted small"><strong>ETA Est:</strong> {{ row.item.EtaDestEst }}</div>
                        <div v-if="row.item.MblReleaseDate" class="text-muted small"><strong>MBL Release:</strong> {{ row.item.MblReleaseDate }}</div>
                        <div v-if="row.item.MblDate" class="text-muted small"><strong>MBL Date:</strong> {{ row.item.MblDate }}</div>
                    </div>
                </template>

                <template slot="VesselVoy" slot-scope="row">
                    <div class="cell-content">
                        <div v-if="row.item.BillingType"><strong>Billing:</strong> {{ truncateWithEllipsis(row.item.BillingType,12) }}</div>
                        <div v-if="row.item.BLType"><strong>BL Type:</strong> {{ truncateWithEllipsis(row.item.BLType,12) }}</div>
                        <div v-if="row.item.FrghtTermsHbl" class="text-muted small"><strong>HBL:</strong> {{ truncateWithEllipsis(row.item.FrghtTermsHbl,12) }}</div>
                        <div v-if="row.item.FrghtTermsMbl" class="text-muted small"><strong>MBL:</strong> {{ truncateWithEllipsis(row.item.FrghtTermsMbl,12) }}</div>
                        <div v-if="row.item.FrghtTermsLiner" class="text-muted small"><strong>Liner:</strong> {{ truncateWithEllipsis(row.item.FrghtTermsLiner,12) }}</div>
                    </div>
                </template>
                
                <template slot="ContainerTypesArr" slot-scope="row">
                     
                </template>
                 <template slot="actions" slot-scope="row">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mb-1">
                             <b-button 
                                size="sm" 
                                variant="outline-info" 
                                @click="openModal('doc', row.item)" 
                                class="mr-1 btn-action"
                                v-b-tooltip.hover title="Summary & Documents"
                            >
                            <i class="fa fa-file-text"></i>
                            </b-button>

                            <b-button 
                                size="sm" 
                                variant="info" 
                                @click="openViewModal(row.item)" 
                                class="mr-1 btn-action"
                                v-b-tooltip.hover title="View Details"
                            >
                                <i class="fa fa-eye text-white"></i>
                            </b-button>

                            <EditCRDRNote
                                v-if="row.item.note_id && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                                :title="'Edit ' + (row.item.NoteType && row.item.NoteType.toLowerCase().includes('credit') ? 'Credit' : 'Debit') + ' Note : ' + row.item.NoteSeries"
                                :note_id="String(row.item.note_id)"
                                :noteSeries="row.item.NoteSeries"
                                :note_page="row.item.Page ? row.item.Page.toLowerCase() : ''"
                                :AgentType="row.item.AgentType"
                                :creditDebitNoteType="row.item.NoteType && row.item.NoteType.toLowerCase().includes('credit') ? '1' : '2'"
                                :approvalStatus="row.item.ApprovalStatus === 'Approved' ? '1' : '0'"
                                :uploadCreditDebit="row.item.PdfLink || ''"
                                :creditDebitNote_Status="row.item.ApprovalStatus === 'Approved' ? '1' : '0'"
                                :JOBID="String(row.item.JobId || row.item.allModuleId)"
                                :JOBNO="row.item.JobNo"
                                :JOBDATE="row.item.JobDate"
                                :JOBTYPE="row.item.JobType"
                                :isIcon="true"
                                class="mr-1"
                            />

                            <b-button 
                                v-if="row.item.PdfLink" 
                                size="sm" 
                                variant="warning" 
                                @click="PrintNote(row.item.JobNo, row.item.PdfLink)" 
                                class="mr-1 btn-action"
                                v-b-tooltip.hover title="View Note PDF"
                            >
                                <i class="fa fa-file-pdf-o text-white"></i>
                            </b-button>

                            <JobWisePaymentsDetails 
                                v-if="row.item.JobId"
                                :allModuleId="Number(row.item.JobId)" 
                                :JobNo="row.item.JobNo"
                                :isIcon="true"
                                iconClass="fa fa-money"
                            />

                            <AssignmentSummary 
                                 v-if="row.item.JobId"
                                :title="'Shipment Summary Tracking'" 
                                :assign_date="moment(row.item.NoteCreatedTime).format('DD/MM/YYYY')"
                                :assign_job_type="row.item.JobType || ''" 
                                :assign_raised_from="'Raised From: ' + (row.item.BranchName || '')"
                                :assign_raised_by="'Raised By: ' + (row.item.NoteCreatedBy || '')" 
                                :fk_all_module_id="row.item.JobId"
                                :jb_series="row.item.JobNo" 
                                :fk_client_id="''"
                                :fk_pod_id="''" 
                                :isIcon="true"
                                iconClass="fa fa-truck"
                            />
                        </div>

                        <div class="d-flex align-items-center">
                            <InvExpSummary 
                                v-if="row.item.JobId"
                                :PMC_title="'Inv Exp Summary Note - ' + row.item.JobNo"
                                :PMC_JOBID="String(row.item.JobId)" 
                                :PMC_JOBNO="row.item.JobNo"
                                :PMC_JOBDATE="moment(row.item.NoteCreatedTime).format('DD/MM/YYYY')" 
                                :PMC_JOBTYPE="row.item.JobType || ''" 
                                :PMC_AgentType="''"
                                :PMC_Client="row.item.AgentColoader || ''" 
                                :PMC_Sline="row.item.shippingLine || ''"
                                :isIcon="true"
                                iconClass="fa fa-list-alt"
                            />

                            <ContainerSummary 
                                v-if="row.item.JobId"
                                :PMC_title="'Container Summary Note - ' + row.item.JobNo"
                                :PMC_JOBID="String(row.item.JobId)" 
                                :PMC_JOBNO="row.item.JobNo"
                                :PMC_JOBDATE="moment(row.item.NoteCreatedTime).format('DD/MM/YYYY')" 
                                :PMC_JOBTYPE="row.item.JobType || ''" 
                                :PMC_AgentType="''"
                                :PMC_Client="row.item.AgentColoader || ''" 
                                :PMC_Sline="row.item.shippingLine || ''"
                                :isIcon="true"
                                iconClass="fa fa-cube"
                            />


                            <b-button 
                                v-if="row.item.ApprovalStatus === 'Pending' && !row.item.PdfLink"
                                size="sm" 
                                variant="outline-success" 
                                @click="approve(row.item, row.index)" 
                                class="mr-1 btn-action"
                                v-b-tooltip.hover title="Approve"
                            >
                            <i class="fa fa-check"></i>
                            </b-button>

                            <b-button 
                            v-if="row.item.ApprovalStatus === 'Pending' && !row.item.PdfLink"
                                size="sm" 
                                variant="outline-danger" 
                                @click="reject(row.item, row.index)"
                                 class="btn-action"
                                 v-b-tooltip.hover title="Reject"
                            >
                            <i class="fa fa-times"></i>
                            </b-button><br/>
                            <b-badge
                                :variant="getStatusVariant(row.item.ApprovalStatus)"
                                class="badge-sm"
                            >
                                {{ row.item.ApprovalStatus }}
                            </b-badge>
                        </div>
                    </div>
                 </template>
            </b-table>
      </b-card-body>

      <b-card-footer class="bg-white border-top py-3">
          <div class="d-flex justify-content-between align-items-center">
             <div class="text-muted small">
                 Showing {{ items.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }} to {{ Math.min(currentPage * perPage, totalRows) }} of {{ totalRows }} entries
             </div>
             <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                class="mb-0 custom-pagination"
                @change="onPageChange"
                pills
            ></b-pagination>
          </div>
      </b-card-footer>
    </b-card>

    <!-- Modals -->
     <b-modal :visible="activeModal === 'doc'" @hidden="activeModal = null" size="xl" hide-footer title="Summary & Documents">
        <div v-if="selectedItem && activeModal === 'doc'">
          <doc-form :allModuleIdProp="selectedItem.JobId" :JOBSERIES="selectedItem.JobNo" />
        </div>
    </b-modal>
    <view-note-details-modal ref="viewModal" />

    <!-- Confirmation Modal -->
    <b-modal 
        ref="common-note-modal"
        id="confirm-modal" 
        :title="confirmTitle" 
        :ok-variant="confirmVariant" 
        @ok="handleConfirm"
        ok-title="YES"
        cancel-title="NO"
        centered
        size="sm"
    >
        <p class="my-4">{{ confirmMessage }}</p>
    </b-modal>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import CreditDebitNoteService from "../../services/CreditDebitNoteService";
import { ModelListSelect } from "vue-search-select";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import CustomLoader from "../common/customLoader.vue";
import DocForm from "../allModuleForm/docLibrary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import ViewNoteDetailsModal from "../common/ViewNoteDetailsModal.vue";
import EditCRDRNote from "../common/editCRDRNote.vue";
import { exportCreditDebitNoteListToExcel } from "../../helper/ExcelExportHelper";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import { URL_BASE_DOC } from "../../helper/constant.js";

export default {
  components: {
    DateRangePicker,
    ModelListSelect,
    CustomLoader,
    DocForm,
    JobWisePaymentsDetails,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    ContainerSummary,
    ViewNoteDetailsModal,
    EditCRDRNote,
  },
  beforeMount() {
     lastVisitPage(this.$router.history.current.fullPath);
    
    this.$store.dispatch("common/setAllBranchList", JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
     this.$store.dispatch("common/setAllClientList", JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch("common/setAllShippingLineList", JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch("common/setAllUserList", JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch("common/setAllAgentColoaderList", JSON.stringify({
        itemCode: "AgentColoaderList",
      })
    );
     this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
     if (globalPermissionStatus("Overseas Agent Assignments")) {
        this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
     } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
    this.initDateRange();
  },
  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      items: [],
      activeTab: 0, // Default to All (Index 0: All, 1: Approved, 2: Pending, 3: Rejected)
      fields: [
        { key: "SN", label: "SN", thClass: 'text-center align-middle', tdClass: 'text-center align-middle' },
        { key: "actions", label: "Actions", thClass: 'text-center align-middle sticky-action-col', tdClass: 'text-center align-middle sticky-action-col' },
        { key: "NoteSeries", label: "Series", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "NoteAmount", label: "Amount", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "SalesSeries", label: "Job Details", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "AgentColoader", label: "Agent/Coloader", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "Shipper", label: "Location", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "VesselVoy", label: "Bl Details", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "ETADest", label: "Dates", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "ApprovalStatus", label: "Status", thClass: 'text-center align-middle', tdClass: 'text-center align-middle' }
      ],
      isBusy: false,
      isExporting: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: "",
      debounce: null,
      filtersVisible: false,
      noteTypeList: [
          { value: '', text: 'All' },
          { value: '1', text: 'Credit Notes' },
          { value: '2', text: 'Debit Notes' }
      ],
      docURL: URL_BASE_DOC,
      dateTypeOptions: [
          { value: 'note_created_at', text: 'Note Date' },
          { value: 'loginTime', text: 'Job Date' }
      ],
      filters: {
          branchfilter: "",
          transportType: null,
          clientFilter: "",
          slineFilter: "",
          userFilter: "",
          noteType: "", // Default to all
          dateType: "loginTime", // Default to Job Date
          agentFilter: "",
          consigneeFilter: ""
      },
      dateRange: { startDate: null, endDate: null },
      transportOptions: [
          { value: 'Export', text: 'Export' },
          { value: 'Import', text: 'Import' }
      ],
      openLeft: 'right',
      // Modal Data
      selectedItem: null,
      activeModal: null,
      // Confirmation Modal Data
      confirmTitle: "",
      confirmMessage: "",
      confirmVariant: "primary",
      confirmActionType: null
    };
  },
  mounted() {
    this.initDateRange();
    this.$nextTick(() => {
        this.getData();
    });
  },
  computed: {
      hasFilters() {
          return this.filters.branchfilter || this.filters.transportType || this.filters.clientFilter || this.filters.slineFilter || this.filters.userFilter;
      }
  },
  methods: {
    moment,
    initDateRange() {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();
        
        let startYear, endYear;
        
        if (currentMonth >= 3) { // April (3) or later
            startYear = currentYear;
            endYear = currentYear + 1;
        } else { // Jan, Feb, Mar
            startYear = currentYear - 1;
            endYear = currentYear;
        }

        const firstDay = new Date(startYear, 3, 1); // April 1st
        const lastDay = new Date(endYear, 2, 31); // March 31st
        
        this.dateRange = { startDate: firstDay, endDate: lastDay };
    },
    debounceSearch() {
        if (this.debounce) clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.currentPage = 1;
            this.getData();
        }, 500);
    },
    onFilterChange() {
        this.currentPage = 1;
        this.getData();
    },
    onTabChange(newTabIndex) {
        this.activeTab = newTabIndex;
        this.currentPage = 1;
        this.getData();
    },
    clearFilters() {
        this.filters.branchfilter = "";
        this.filters.transportType = null;
        this.filters.clientFilter = "";
        this.filters.slineFilter = "";
        this.filters.userFilter = "";
        this.filters.noteType = "";
        this.filters.dateType = "loginTime";
        this.filters.agentFilter = "";
        this.filters.consigneeFilter = "";
        this.initDateRange();
        this.getData();
    },
    async getData() {
      this.isBusy = true;
      try {
        // Map tab index to approval status (isApproved)
    // Tab 0: All -> undefined
    // Tab 1: Approved -> 1
    // Tab 2: Pending -> 0
    // Tab 3: Rejected -> 2
    let isApproved;
    if (this.activeTab === 1) isApproved = 1;
    else if (this.activeTab === 2) isApproved = 0;
    else if (this.activeTab === 3) isApproved = 2;
    
    const payload = {
        pageNo: this.currentPage,
        pageSize: this.perPage,
        isAll: 0,
        isSelectedColumn: 0,
        creditDebitNoteType: this.filters.noteType, 
        isApproved: isApproved, // Map tab to isApproved
        search_txt: this.filter,
        Filters: {
            transportType: this.filters.transportType,
            branchFilter: this.filters.branchfilter,
            clientFilter: this.filters.clientFilter,
            slineFilter: this.filters.slineFilter,
            userFilter: this.filters.userFilter,
            agentFilter: this.filters.agentFilter,
            consigneeFilter: this.filters.consigneeFilter,
            dateType: this.filters.dateType,
            noteType: this.filters.noteType==="1"?"CR":this.filters.noteType==="2"?"DR":"",
        },
        dateRange: this.dateRange
    };
        
        const response = await CreditDebitNoteService.getPendingNotes(payload);
        console.log("Pending Notes Response:", response.data);
        if (response.data.status === 200 || response.data.type === 'success') {
             const allData = response.data.data.data;
             this.items = allData;
             this.totalRows = response.data.data.pagination.count;
        } else {
            this.items = [];
            this.totalRows = 0;
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
         console.log("Failed to load data", {
            title: "Error",
            variant: "danger",
            solid: true
        });
      } finally {
        this.isBusy = false;
      }
    },
    onPageChange(page) {
        this.currentPage = page;
        this.getData();
    },
    clearFilter() {
        this.filter = "";
        this.getData();
    },
    openModal(type, item) {
        this.selectedItem = item;
        this.activeModal = type;
    },
    async exportToExcel() {
        this.isExporting = true;
        try {
            // Map tab index to approval status (isApproved)
            let isApproved;
            if (this.activeTab === 1) isApproved = 1;
            else if (this.activeTab === 2) isApproved = 0;
            else if (this.activeTab === 3) isApproved = 2;

            const payload = {
                pageNo: 1,
                pageSize: 100000, 
                isAll: 1, // Fetch all records for export
                isSelectedColumn: 0,
                creditDebitNoteType: this.filters.noteType, 
                isApproved: isApproved,
                search_txt: this.filter,
                Filters: {
                    transportType: this.filters.transportType,
                    branchFilter: this.filters.branchfilter,
                    clientFilter: this.filters.clientFilter,
                    slineFilter: this.filters.slineFilter,
                    userFilter: this.filters.userFilter,
                    agentFilter: this.filters.agentFilter,
                    consigneeFilter: this.filters.consigneeFilter,
                    dateType: this.filters.dateType,
                    noteType: this.filters.noteType==="1"?"CR":this.filters.noteType==="2"?"DR":"",
                },
                dateRange: this.dateRange
            };

            const response = await CreditDebitNoteService.getPendingNotes(payload);
            
            if (response.data.status === 200 || response.data.type === 'success') {
                 const allData = response.data.data.data;
                 if(allData && allData.length > 0) {
                     await exportCreditDebitNoteListToExcel(allData, "CreditDebitNote_Export.xlsx");
                     console.log("Export successful", { title: "Success", variant: "success", solid: true });
                 } else {
                     console.log("No data to export", { title: "Info", variant: "warning", solid: true });
                 }
            } else {
                 console.log("Failed to fetch data for export", { title: "Error", variant: "danger", solid: true });
            }

        } catch (error) {
            console.error("Export Error:", error);
            console.log("Export failed", { title: "Error", variant: "danger", solid: true });
        } finally {
            this.isExporting = false;
        }
    },
    async approve(item, index) {
        this.selectedItem = item;
        this.confirmTitle = "Confirm Approval";
        this.confirmMessage = `Are you sure you want to approve Note?`;
        this.confirmVariant = "success";
        this.confirmActionType = 'approve';
        this.$refs["common-note-modal"].show();
    },
    async reject(item, index) {
        this.selectedItem = item;
        this.confirmTitle = "Confirm Rejection";
        this.confirmMessage = `Are you sure you want to reject Note?`;
        this.confirmVariant = "danger";
        this.confirmActionType = 'reject';
        this.$refs["common-note-modal"].show();
    },
    async handleConfirm() {
        if (!this.selectedItem) return;

        const item = this.selectedItem;
        const payload = {
             noteId: item.note_id,
        };

        try {
            let response;
            if (this.confirmActionType === 'approve') {
                 response = await CreditDebitNoteService.approveNote(payload);
            } else if (this.confirmActionType === 'reject') {
                 response = await CreditDebitNoteService.rejectNote(payload);
            } else {
                return;
            }

            console.log("Response:", response);

            if (response && (response.data.type === 'success' )) {
                this.alert.content = response.data.message || `Note ${this.confirmActionType}d successfully`;
                this.$refs["addPop"].open();
            } else {
                 throw new Error((response && response.data && response.data.message) || `Failed to ${this.confirmActionType} note`);
            }
            this.getData(); // Refresh list
        } catch (error) {
            console.error(`${this.confirmActionType} Error:`, error);
            const message = (error.response && error.response.data && error.response.data.message) || (error.message || `An error occurred while ${this.confirmActionType}ing`);
            this.alert.content = message;
            this.$refs["addPop"].open();
        } finally {
             this.selectedItem = null;
             this.confirmActionType = null;
             this.$refs["common-note-modal"].hide();
        }
    },
    getStatusVariant(status) {
        if (status === 'Approved' || status === 'Yes' || status === 'Completed' || status === 'Sended') return 'success';
        if (status === 'Rejected' || status === 'No' || status === 'Pending' || status === 'Not Send') return 'danger';
        return 'warning';
    },
    truncateWithEllipsis(text, maxLength = 20) {
        if (!text) return "";
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + "...";
        }
        return text;
    },
    PrintNote(assignmentNo, uploadCreditDebit) {
      if (!assignmentNo || !uploadCreditDebit) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        assignmentNo.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    openViewModal(item) {
        if (this.$refs.viewModal) {
             const modalItem = Object.assign({}, item, {
                note_id: item.note_id || item.CreditDebitNoteId,
                 page: item.Page || item.PageName || 'fcl' 
            });
            this.$refs.viewModal.openModal(modalItem);
        }
    }
  }
};
</script>

<style scoped>
.approval-list-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding: 20px;
}

/* Cell Content Styling */
.cell-content {
    line-height: 1.6;
    font-size: 0.875rem;
}

.cell-content > div {
    margin-bottom: 4px;
    white-space: nowrap;
}

.cell-content > div:last-child {
    margin-bottom: 0;
}

.cell-content strong {
    color: #495057;
    font-weight: 600;
    margin-right: 4px;
}

/* Status Column Styling */
.status-column .badge-sm {
    font-size: 0.7rem;
    padding: 3px 8px;
}

/* Badge Styling */
.badge-sm {
    font-size: 0.75rem;
    padding: 4px 8px;
    font-weight: 500;
}

/* Custom Tabs */
.custom-pills .nav-link {
    color: #6c757d;
    font-weight: 500;
    padding: 10px 20px;
    border-radius: 20px;
    transition: all 0.3s ease;
}

.custom-pills .nav-link.active {
    background-color: #007bff;
    color: white;
    box-shadow: 0 4px 6px rgba(0, 123, 255, 0.2);
}

.custom-pills .nav-link:hover:not(.active) {
    background-color: #f8f9fa;
    color: #0056b3;
}

/* Table Styles */
.custom-table {
    table-layout: auto;
}

.custom-table ::v-deep thead th {
    border-top: none;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.85rem;
    letter-spacing: 0.5px;
    color: #495057;
    white-space: nowrap;
    vertical-align: middle;
}

.custom-table ::v-deep tbody td {
    vertical-align: top;
    padding: 12px 8px;
}

/* Sticky Action Column */
.sticky-action-col {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 10;
    box-shadow: 2px 0 5px rgba(0,0,0,0.1);
}

.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: inline-block;
}

.custom-table ::v-deep tbody tr {
    transition: background-color 0.2s ease;
}

.custom-table ::v-deep tbody tr:hover {
    background-color: #f8f9fa;
}

.custom-table ::v-deep tbody tr:hover .sticky-action-col {
    background-color: #f8f9fa;
}

.btn-action {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.btn-action:hover {
    transform: scale(1.1);
}

/* Search input focus */
.form-control:focus {
    box-shadow: none;
    border-color: #80bdff;
}
</style>



// WEBPACK FOOTER //
// ApprovalList.vue?310c4412